export default __webpack_public_path__ + "281b8a227998c6d8af98c181878f4674.png";